import { store } from '@utils/configStore'
import { invoiceManagementReducer } from './slice'

export const injectInvoiceManagement = () => store.injectReducer('invoiceManagement', invoiceManagementReducer)
